<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div
            class="router-transitions container-fluid flex-grow-1 container-p-y"
          >
            <router-view />
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar';
import LayoutSidenav from './LayoutSidenav';
import LayoutFooter from './LayoutFooter';

export default {
  name: 'app-layout-2',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter
  },

  mounted() {
    this.layoutHelpers.init();
    this.layoutHelpers.update();
    this.layoutHelpers.setAutoUpdate(true);
  },

  beforeDestroy() {
    this.layoutHelpers.destroy();
  },

  methods: {
    closeSidenav() {
      this.layoutHelpers.setCollapsed(true);
    }
  }
};
</script>

<style lang="scss">
.custom-notification {
  padding: 15px;
  margin: 0 5px 5px;

  font-size: 1em;

  color: #fff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;

  .notification-content {
    font-size: 0.96em;
    line-height: 1.2em;
  }

  &.info {
    background: #44a4fc;
    border-left-color: #187fe7;
  }

  &.warn {
    background: #eea426;
    border-left-color: #e36804;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.success {
    background: #68cd86;
    border-left-color: #42a85f;
  }
}
</style>
